import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import {
  SimpleLoading,
  PromotionalFooterPure,
  GridSimpleReadHLPure,
  ButtonHLPure,
  BoxSomeHeadersGLPure,
  DialogSystemGLPure,
  HeaderHLPure,
  ArrowBtnHLPure,
} from "../../pures";
import "./followup-new-recruiter.css";
import ChatBoxGLPure from "../../pures/chatBoxGL/chatBoxGL.pure";
import PdfReader from "../../pures/adobePfdReader/PdfReader";
import FollowUpConfigurationsView from "../follow-up-actions-contracts/follow-up-actions-contracts-discussion.view";

const FollowUpNewRecruiterView = (props) => {
  const {
    contract,
    showLoadingRequesting,
    showCompletedRequesting,
    showErrorRequesting,
    toggleLoadingRequesting,
    toggleCompletedRequesting,
    toggleErrorRequesting,
    createMessage,
    token,
  } = props;
  const { t } = useTranslation();
  const [filePDF, setFilePDF] = useState({});
  const [nameComponentUser, setNameComponentUser] = useState("");
  const [showDetails, setShowDetails] = useState(false);

  const handleInputChange = (e) => {
    let file = e.target.files[0];
    setFilePDF(file);
    let reader = new FileReader();
    reader.readAsDataURL(file);
  };
  const [selectedDocument, setSelectedDocument] = useState({});
  const [urlPdf, setUrlPdf] = useState(props.documents[0]?.path);
  const [showPdf, setShowPdf] = useState(true);

  const pdf = useMemo(
    () => (
      <PdfReader
        className="pdfReader"
        url={urlPdf || props.documents[0]?.path}
        awsURL
        src={urlPdf || props.documents[0]?.path}
      ></PdfReader>
    ),
    [urlPdf, props.documents]
  );

  useEffect(() => {
    setUrlPdf(props.documents[0]?.path)
  }, [props.documents])

  const handleBtnDiscussion = () => {
    setNameComponentUser("Discusion");
    setShowDetails(true);
  };


  const mobileResolution = useMediaQuery("(max-width:660px)");

  const handleIconBtn = (dataItem) => {
    setUrlPdf(dataItem.path);
    setShowPdf(true);
  };

  return (
    <div className="digitalContractDashboard-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <>
          {showLoadingRequesting ? (
            <DialogSystemGLPure
              showLoadingRequesting={showLoadingRequesting}
              toggleLoadingRequesting={toggleLoadingRequesting}
            />
          ) : null}
          {showErrorRequesting ? (
            <DialogSystemGLPure
              showErrorRequesting={showErrorRequesting}
              toggleErrorRequesting={toggleErrorRequesting}
            // messages={messages}
            />
          ) : null}
          {showCompletedRequesting ? (
            <DialogSystemGLPure
              showCompletedRequesting={showCompletedRequesting}
              toggleCompletedRequesting={toggleCompletedRequesting}
            />
          ) : null}

          <Container
            xs={12}
            lg={12}
            md={12}
            sm={12}
            spacing={4}
            className="digitalContractDashboard-container"
          >
            <Grid
              container
              className="digitalContractDashboard-body"
              xs={12}
              lg={12}
              md={12}
              sm={12}
              es={12}
            >
              <>
                {/*Header*/}
                <Grid
                  item
                  lg={12}
                  md={12}
                  xs={12}
                  sm={12}
                  className="digitalContractDashboard-header"
                >
                  <HeaderHLPure
                    subtitleActive={false}
                    title={
                      `${t("followupNewRecruiter.header.title")} / ${props.titleHeader}`
                      // props.workflowButtons.statusCurrent.name
                    }
                  />
                </Grid>

                {showDetails && nameComponentUser ? (
                  <FollowUpConfigurationsView
                    nameComponentUser={nameComponentUser}
                    hideShowDetails={() => {
                      setShowDetails(false);
                      setNameComponentUser("");
                    }}
                    setShowDetails={setShowDetails}
                    setNameComponentUser={setNameComponentUser}
                    // status={status}
                    // setUrlPdf={setUrlPdf}
                    // setQuestionsAnswered={setQuestionsAnswered}
                    {...props}
                    conversation={props.conversation}
                    usersChat={props.usersChat}
                    handleInputChange={handleInputChange}
                    createMessage={createMessage}
                  />
                ) : (
                  <>
                    {/*Container primera seccion de items, fila*/}
                    <Grid
                      container
                      lg={12}
                      md={12}
                      xs={12}
                      sm={12}
                      className="followupNewRecruiter-containerBody"
                    >
                      {/*Cards container */}
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <BoxSomeHeadersGLPure
                          titleOne={t("followupNewRecruiter.boxHeader.title1")}
                          titleTwo={t("followupNewRecruiter.boxHeader.title2")}
                          titleThree={"RFC"}
                          titleFour={t("followupNewRecruiter.boxHeader.title4")}
                          subtitleActive={true}
                          subtitleOne={contract.name}
                          subtitleTwo={contract.updatedByUser}
                          subtitleThree={contract.rfc}
                          subtitleFour={props.registerDate}
                        />
                      </Grid>
                      {/*Cards Spinners containers*/}
                      <Grid
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        className="followupNewRecruiter-containerDetailDocument"
                      >
                        <Grid
                          item
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className="followupNewRecruiter-containerChatGrid"
                        >
                          <Grid
                            item
                            className="followupNewRecruiter-containerGrid"
                          >
                            <GridSimpleReadHLPure
                              dataGrid={props.documents.map(item => item.path == urlPdf ? { ...item, selected: true } : { ...item, selected: false })}
                              skip={0}
                              take={5}
                              titleRow1={t("followupNewRecruiter.grid.generalTitle")}
                              fieldRow1={"documentName"}
                              fieldSubtitle={"registerDate"}
                              textSubtitle={"textSubtitle"}
                              styleCol1={"qrSignedDocument-cellItemStyleCol1"}
                              onSelectedItem={setSelectedDocument}
                              filter={true}
                              fieldImg={"logo"}
                              // handleOnChange={(e, dataItem) =>
                              //   handleOnChangeUpload(e, dataItem)
                              // }
                              column2Status={false}
                              pageableGrid={true}
                              acceptButton={"application/pdf"}
                              btnFileActiveCol2={true}
                              iconArrow={true}
                              iconArrowClick={true}
                              handleIconArrow={(dataItem) =>
                                handleIconBtn(dataItem)
                              }
                              rowClick={true}
                            />
                          </Grid>
                          {!mobileResolution ? (
                            <Grid
                              item
                              lg={12}
                              md={12}
                              sm={12}
                              xs={12}
                              className="followupNewRecruiter-chat"
                            >
                              <Grid className="followupNewRecruiter-headerUsersChat">
                                <span className="followupNewRecruiter-titleGrid">
                                  {t("followupNewRecruiter.headerChat")}
                                </span>
                                <div className="followupNewRecruiter-containersAvatars">
                                  {props.membersChat.map((item, index) => (
                                    <div>
                                      <img
                                        key={index}
                                        src={item.avatarUrl}
                                        className="followupNewRecruiter-avatar"
                                        alt={item.name}
                                      />
                                    </div>
                                  ))}
                                </div>
                              </Grid>
                              <Grid>
                                <ChatBoxGLPure
                                  user={props.usersChat}
                                  widthChat={1200}
                                  heightChat={300}
                                  // placeholderChat={"Escribe algo"}
                                  handleInputChange={handleInputChange}
                                  createMessage={createMessage}
                                  token={token}
                                  conversation={props.conversation}
                                />
                              </Grid>
                            </Grid>
                          ) : (
                            ""
                          )}
                        </Grid>
                        <Grid
                          item
                          lg={6}
                          md={6}
                          sm={12}
                          xs={12}
                          className={"followupNewRecruiter-containerPDF"}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            className="followupNewRecruiter-pdf"
                          >
                            {pdf}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      className={"followupNewRecruiter-containerBtns"}
                    >
                      <Grid className="followupNewRecruiter-button">
                        <ButtonHLPure
                          nameBtn={t("button.exit")}
                          onClickBtn={props.handleBtnGo}
                        />
                      </Grid>
                      <Grid className="followupNewRecruiter-button">
                        <ButtonHLPure
                          nameBtn={props.buttonBack}
                          onClickBtn={props.backBtn}
                        />
                      </Grid>
                      <Grid>
                        <ButtonHLPure
                          primary
                          nameBtn={props.buttonNext}
                          onClickBtn={props.nextBtn}
                        />
                      </Grid>
                      {mobileResolution ? (
                        <div className="">
                          <ArrowBtnHLPure
                            textArrowBtn={t("followupNewRecruiter.grid.arrowBtnText")}
                            primary={true}
                            onClickArrowBtn={(e) => handleBtnDiscussion(e)}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </Grid>
                  </>
                )}
              </>

              {/*Seccion de fila para footer */}
              <Grid item xs={12} lg={12} md={12} sm={12}>
                <PromotionalFooterPure />
              </Grid>
            </Grid>
          </Container>
        </>
      )}
    </div>
  );
};

export default FollowUpNewRecruiterView;
